import * as $ from "jquery";
import * as mojs from "mo-js";

export function getFavoriteProducts(): string[] {
	let productIds: string[] = [];
	if (localStorage.getItem('favorites')) {
		productIds = JSON.parse(localStorage.getItem('favorites'));
	}

	return productIds;
}

export function checkOnPageFavorites(): void {
	$('.js-save-for-later').each(function() {
		if ($(this).data('modelnumber')) {
			let favorites = getFavoriteProducts();
			updateSavedState(this, favorites);
		}
	});
}

export function updateSavedState(el, favorites) {
	let modelNumber = $(el).data('modelnumber');

	if (favorites.indexOf(modelNumber) > -1) {
		$(el).find('.favorite-toggle').addClass('state-checked');
		let $label = $(el).find('.js-save-for-later-label');

		if ($label.length && $label.data('checked')) {
			$label.text($label.data('checked'));
		}
	}
}

export function addFavorite(modelNumber) {
	let productIds = getFavoriteProducts();

	if (productIds.indexOf(modelNumber) < 0) {
		productIds.push(modelNumber);
	}

	localStorage.setItem('favorites', JSON.stringify(productIds));
}

export function removeFavorite(modelNumber) {
	let productIds = getFavoriteProducts();

	if (productIds.indexOf(modelNumber) > -1) {
		productIds.splice(productIds.indexOf(modelNumber), 1);
	}

	localStorage.setItem('favorites', JSON.stringify(productIds));
}

export function init() {
	if (window['favoriteToggleInitialized']) { return; }

	const RADIUS = 26;
	/*const burst = new mojs.Burst({
		left: 0,
		top: -1,
		radius: {6: RADIUS - 7},
		angle: 45,
		children: {
			shape: 'line',
			radius: RADIUS / 7.3,
			scale: 1,
			stroke: '#ecc800',
			strokeDasharray: '100%',
			strokeDashoffset: {'-100%': '100%'},
			degreeShift: 'stagger(0,-5)',
			duration: 450,
			delay: 200,
			easing: 'quad.out',
		}
	});*/

	// const heartTimeline = new mojs.Timeline();
	// heartTimeline.add(burst);

	// window['heartTimeline'] = heartTimeline;

	checkOnPageFavorites();

	$(document).on('click', '.js-save-for-later', function(e) {
		e.preventDefault();
		e.stopPropagation();

		let $this = $(this);
		let $heart = $this.find('.favorite-toggle');
		let $label = $this.find('.js-save-for-later-label');
		let isChecked = $heart.hasClass('state-checked');
		let modelNumber = $this.data('modelnumber');

		$heart.toggleClass('state-checked');

		// If this is inside an Angular component, let Angular take care of the class change
		if (!$this.hasClass('ng-star-inserted')) {
			$this.toggleClass('state-favorited');

			if (!isChecked) {
				addFavorite(modelNumber);
			} else {
				removeFavorite(modelNumber);
			}

			let favorites = getFavoriteProducts();
			updateSavedState(this, favorites);

			if (!isChecked && $label.length && $label.data('checked')) {
				$label.text($label.data('checked'));
			} else if ($label.length && $label.data('unchecked')) {
				$label.text($label.data('unchecked'));
			}

			// This event triggers the Favorites counter in the nav to update
			window.dispatchEvent(new Event('favorites'));
		}

		let pos = $heart.offset();
		let burstCoords = {x: pos.left +  $heart.width() / 2, y: pos.top + $heart.height() / 2};

		if (!isChecked) {
			// burst.tune(burstCoords);
			// heartTimeline.replay();
		}
	});

	window['favoriteToggleInitialized'] = true;
}



// WEBPACK FOOTER //
// ./js/PFF/modules/favoriteToggle.ts